"use strict";

import Vue from "vue";
import axios from "axios";
// import localForge from "localforage";
import store from "@/store";
import router from "@/router";

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

let config = {
  // baseURL: process.env.baseURL || process.env.apiUrl || ""
  // timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
  async function(config) {
    // Do something before request is sent
    try {
      const token = store.state.auth.token;
      if (token) {
        config.headers["Authorization"] = `Bearer ${store.state.auth.token}`;
      }
    } catch (error) {
      console.log(error);
    }
    return config;
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
_axios.interceptors.response.use(
  function(response) {
    // Do something with response data
    if (response.headers["x-token"]) {
      console.log("updating auth token...");
      store.commit("UPDATE_AUTH_TOKEN", response.headers["x-token"]);
    }
    return response;
  },
  function(error) {
    if (error.response.status === 403) {
      router.push("/admin");
    }
    return Promise.reject(error);
  }
);

Plugin.install = function(Vue) {
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      }
    },
    $axios: {
      get() {
        return _axios;
      }
    }
  });
};

Vue.use(Plugin);

export default Plugin;
